module.exports = __webpack_public_path__ + "static/media/ic_facebook_login.5b076a9a.svg";